// extracted by mini-css-extract-plugin
export var colorSquare = "_nz-0";
export var danger = "_nz-5";
export var lightPink = "_nz-8";
export var neutralBlue = "_nz-7";
export var neutralYellow = "_nz-6";
export var normal = "_nz-1";
export var primary = "_nz-2";
export var primaryLight = "_nz-3";
export var solidBlack = "_nz-g";
export var solidGreen = "_nz-b";
export var solidLightBlue = "_nz-d";
export var solidNavy = "_nz-c";
export var solidOrange = "_nz-f";
export var solidPink = "_nz-e";
export var solidRed = "_nz-9";
export var solidYellow = "_nz-a";
export var success = "_nz-4";